//sticky cart click
$(document).ready(function(){
  $("body").on("click", ".prohide svg", function () {
    $(".slidercartpro").hide();
  });
});

$(window).on("scroll", function () {
  var scrollPosition = $(window).scrollTop();

  var sectionEnd =
    $(".custom__main-pdp").offset().top + $(".custom__main-pdp").outerHeight();
  if (scrollPosition >= sectionEnd) {
    $("#sticky_cart").fadeIn();
  } else {
    $("#sticky_cart").fadeOut();
  }
});

$(document).on("click", ".tablinks", function () {
  var $this = $(this);
  var cityName = $this.data("city");
  var $section = $this.closest(".tab-section");

  // Hide all tab content and remove active class in the current section
  $section.find(".tabcontent").hide().removeClass("active");
  $section.find(".tablinks").removeClass("active");

  // Show the current tab content and set active class
  $section
    .find("#" + cityName)
    .show()
    .addClass("active");
  $this.addClass("active");
});

document.addEventListener("DOMContentLoaded", () => {
  let isDown = false;
  let startX;
  let scrollLeft;
  const slider = document.querySelector(".items");

  if (slider) {
    // Check if slider element exists
    const end = () => {
      isDown = false;
      slider.classList.remove("active");
    };

    const start = (e) => {
      isDown = true;
      slider.classList.add("active");
      startX = e.pageX || e.touches[0].pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    };

    const move = (e) => {
      if (!isDown) return;

      e.preventDefault();
      const x = e.pageX || e.touches[0].pageX - slider.offsetLeft;
      const dist = x - startX;
      slider.scrollLeft = scrollLeft - dist;
    };

    // Add event listeners only if slider element exists and has children
    if (slider.children.length > 0) {
      slider.addEventListener("mousedown", start);
      slider.addEventListener("touchstart", start);

      slider.addEventListener("mousemove", move);
      slider.addEventListener("touchmove", move);

      slider.addEventListener("mouseleave", end);
      slider.addEventListener("mouseup", end);
      slider.addEventListener("touchend", end);
    }
  }
});

$(document).ready(function () {
  $("#tabs-nav li:first-child").addClass("active");
  $(".tab-content").hide();
  $(".tab-content:first").show();

  $("#tabs-nav li").click(function () {
    var tabContentSelector = $(this).data("tab");
    $("#tabs-nav li").removeClass("active");
    $(this).addClass("active");
    $(".tab-content").hide();
    $(tabContentSelector).fadeIn();
  });
  $("button.prohide svg").click(function () {
    $(".slidercartpro").hide();
  });
});